export const black = "#000000";
const gray50 = "#EAEAEB";
const gray100 = "#CBCCCE";
const gray200 = "#A8AAAE";
const gray300 = "#85878D";
const gray400 = "#6A6E74";
const gray500 = "#50545C";
const gray600 = "#494D54";
const gray700 = "#40434A";
const gray800 = "#373A41";
const gray900 = "#272930";
export const gray = {
    50: gray50,
    100: gray100,
    200: gray200,
    300: gray300,
    400: gray400,
    500: gray500,
    600: gray600,
    700: gray700,
    800: gray800,
    900: gray900,
};
const lightGray50 = "#FCFCFD";
const lightGray100 = "#F7F8FB";
const lightGray200 = "#F2F4F8";
const lightGray300 = "#EDEFF5";
const lightGray400 = "#E9EBF2";
const lightGray500 = "#E5E8F0";
const lightGray600 = "#E2E5EE";
const lightGray700 = "#DEE2EC";
const lightGray800 = "#DADEE9";
const lightGray900 = "#D3D8E5";
export const lightGray = {
    50: lightGray50,
    100: lightGray100,
    200: lightGray200,
    300: lightGray300,
    400: lightGray400,
    500: lightGray500,
    600: lightGray600,
    700: lightGray700,
    800: lightGray800,
    900: lightGray900,
};
export const white = "#FFFFFF";
const auvikLavender50 = "#EEECF9";
const auvikLavender100 = "#BBADFD";
const auvikLavender500 = "#8E77FB";
const auvikLavender800 = "#725FC9";
const auvikLavender900 = "#554797";
export const auvikLavender = {
    50: auvikLavender50,
    100: auvikLavender100,
    500: auvikLavender500,
    800: auvikLavender800,
    900: auvikLavender900,
};
const auvikPurple50 = "#E4DEFC";
const auvikPurple100 = "#CABEFA";
const auvikPurple500 = "#7A5CF2";
const auvikPurple800 = "#493791";
const auvikPurple900 = "#312561";
export const auvikPurple = {
    50: auvikPurple50,
    100: auvikPurple100,
    500: auvikPurple500,
    800: auvikPurple800,
    900: auvikPurple900,
};
const auvikEggplant50 = "#AFA3B1";
const auvikEggplant100 = "#5F4763";
const auvikEggplant500 = "#37193C";
const auvikEggplant800 = "#2C1430";
const auvikEggplant900 = "#210F24";
export const auvikEggplant = {
    50: auvikEggplant50,
    100: auvikEggplant100,
    500: auvikEggplant500,
    800: auvikEggplant800,
    900: auvikEggplant900,
};
const auvikCyan50 = "#ECF1F8";
const auvikCyan100 = "#B2D0FA";
const auvikCyan500 = "#7FB0F6";
const auvikCyan800 = "#668EC5";
const auvikCyan900 = "#4C6A94";
export const auvikCyan = {
    50: auvikCyan50,
    100: auvikCyan100,
    500: auvikCyan500,
    800: auvikCyan800,
    900: auvikCyan900,
};
const auvikPink50 = "#FFDDE3";
const auvikPink100 = "#FF98AC";
const auvikPink500 = "#FF5374";
const auvikPink800 = "#CC425D";
const auvikPink900 = "#993246";
export const auvikPink = {
    50: auvikPink50,
    100: auvikPink100,
    500: auvikPink500,
    800: auvikPink800,
    900: auvikPink900,
};
const auvikYellow50 = "#FFF0CC";
const auvikYellow100 = "#FFD366";
const auvikYellow500 = "#FFB600";
const auvikYellow800 = "#CC9200";
const auvikYellow900 = "#996D00";
export const auvikYellow = {
    50: auvikYellow50,
    100: auvikYellow100,
    500: auvikYellow500,
    800: auvikYellow800,
    900: auvikYellow900,
};
const auvikOrange50 = "#FFF3EB";
const auvikOrange100 = "#FFA366";
const auvikOrange500 = "#FF6600";
const auvikOrange800 = "#CC5200";
const auvikOrange900 = "#993D00";
export const auvikOrange = {
    50: auvikOrange50,
    100: auvikOrange100,
    500: auvikOrange500,
    800: auvikOrange800,
    900: auvikOrange900,
};
const auvikRed50 = "#FFEBED";
const auvikRed100 = "#FF6675";
const auvikRed500 = "#FF0019";
const auvikRed800 = "#CC0014";
const auvikRed900 = "#99000F";
export const auvikRed = {
    50: auvikRed50,
    100: auvikRed100,
    500: auvikRed500,
    800: auvikRed800,
    900: auvikRed900,
};
const auvikGreen50 = "#F0FAF4";
const auvikGreen100 = "#8BDAAC";
const auvikGreen500 = "#3DC175";
const auvikGreen800 = "#319A5E";
const auvikGreen900 = "#257446";
export const auvikGreen = {
    50: auvikGreen50,
    100: auvikGreen100,
    500: auvikGreen500,
    800: auvikGreen800,
    900: auvikGreen900,
};
const auvikLime50 = "#F3FBE4";
const auvikLime100 = "#E0F5BC";
const auvikLime500 = "#97DC21";
const auvikLime800 = "#7ACE14";
const auvikLime900 = "#69C50B";
export const auvikLime = {
    50: auvikLime50,
    100: auvikLime100,
    500: auvikLime500,
    800: auvikLime800,
    900: auvikLime900,
};
const auvikBrown50 = "#F1EDE7";
const auvikBrown100 = "#DCD3C4";
const auvikBrown500 = "#8B6D3A";
const auvikBrown800 = "#6E5025";
const auvikBrown900 = "#5B3E18";
export const auvikBrown = {
    50: auvikBrown50,
    100: auvikBrown100,
    500: auvikBrown500,
    800: auvikBrown800,
    900: auvikBrown900,
};
const auvikSkyBlue50 = "#E5F3FD";
const auvikSkyBlue100 = "#BEE0F9";
const auvikSkyBlue500 = "#2697EC";
const auvikSkyBlue800 = "#177AE4";
const auvikSkyBlue900 = "#0D69DF";
export const auvikSkyBlue = {
    50: auvikSkyBlue50,
    100: auvikSkyBlue100,
    500: auvikSkyBlue500,
    800: auvikSkyBlue800,
    900: auvikSkyBlue900,
};
const eggplantGray50 = "#EFEDEF";
const eggplantGray100 = "#DFDAE0";
const eggplantGray200 = "#CFC8D0";
const eggplantGray300 = "#BFB5C1";
const eggplantGray400 = "#AFA3B1";
const eggplantGray500 = "#8C828E";
const eggplantGray600 = "#69626A";
const eggplantGray700 = "#464147";
const eggplantGray800 = "#232123";
const eggplantGray900 = "#000000";
export const eggplantGray = {
    50: eggplantGray50,
    100: eggplantGray100,
    200: eggplantGray200,
    300: eggplantGray300,
    400: eggplantGray400,
    500: eggplantGray500,
    600: eggplantGray600,
    700: eggplantGray700,
    800: eggplantGray800,
    900: eggplantGray900,
};
const lavenderGray50 = "#FCFBFE";
const lavenderGray100 = "#F8F7FD";
const lavenderGray200 = "#F5F4FB";
const lavenderGray300 = "#F1F0FA";
const lavenderGray400 = "#EEECF9";
const lavenderGray500 = "#D6D4E2";
const lavenderGray600 = "#BEBDC7";
const lavenderGray700 = "#8F8E95";
const lavenderGray800 = "#373A41";
const lavenderGray900 = "#272930";
export const lavenderGray = {
    50: lavenderGray50,
    100: lavenderGray100,
    200: lavenderGray200,
    300: lavenderGray300,
    400: lavenderGray400,
    500: lavenderGray500,
    600: lavenderGray600,
    700: lavenderGray700,
    800: lavenderGray800,
    900: lavenderGray900,
};
// web-client use
export const Colors = {
    auvikBrown,
    auvikCyan,
    auvikEggplant,
    auvikGreen,
    auvikLavender,
    auvikLime,
    auvikOrange,
    auvikPink,
    auvikPurple,
    auvikRed,
    auvikSkyBlue,
    auvikYellow,
    black,
    eggplantGray,
    gray,
    lavenderGray,
    lightGray,
    white,
};
